export const GET_PERSONAL_ACCOUNT_INFO = "GET_PERSONAL_ACCOUNT_INFO";
export const GET_PERSONAL_ACCOUNTS = "GET_PERSONAL_ACCOUNTS";

export default {
  GET_PERSONAL_ACCOUNT_INFO,
  GET_PERSONAL_ACCOUNTS
};
